module.exports = __webpack_public_path__ + "img/bgc.2becf032.png";